import React from 'react';
import CrossRoad from "../UI/Crossroad";

const CrossRoad_11DRed_11FBlue = () => <CrossRoad coords="2140.000000, 602.000000"/>;

export default CrossRoad_11DRed_11FBlue;